import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Wrapper } from './ResponsibleFilter.styled';
import { UserSelect } from '../../../../../../../components/_form';
import { useTaskSidebarContext } from '../../../../../../../contexts/TaskSidebarContext';
import { IOption } from '../../../../../../../components/_form/Select/Select';
import { useUsersQuery } from 'hooks/queries/useUsersQuery';
import { mapUsersToSelectOptions } from 'utilities/userSelectOption';

export const ResponsibleFilter: React.FC = () => {
  const { data: users = [] } = useUsersQuery();
  const usersList = useMemo(
    () => mapUsersToSelectOptions(users),
    [users]
  );
  const { t } = useTranslation();
  const {
    filters: { responsiblePersons },
    setFilters
  } = useTaskSidebarContext();

  const selected = () =>
    usersList.filter((el) => responsiblePersons.value.includes(el.value));

  const handleOnChange = (val: IOption[]) => {
    setFilters((prevState) => {
      return {
        ...prevState,
        responsiblePersons: {
          label:
            val.length > 0
              ? t('tasks.responsible') +
                ' - ' +
                val.map((el) => el.label).join(', ')
              : '',
          value: val.map((el) => el.value)
        }
      };
    });
  };

  return (
    <Wrapper>
      <UserSelect
        isMulti
        options={usersList}
        selectedOptions={selected()}
        onChange={handleOnChange}
      />
    </Wrapper>
  );
};
